module.exports = __webpack_public_path__ + "static/media/wiip-icons.37b87c52.eot";